import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { REFRESH_KEY, stashLoginReturnPath, TOKEN_KEY, refreshAccessToken } from '../services/authService';

function jwtExpMs(token) {
  if (!token || typeof token !== 'string') return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    let b64 = part.replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    const json = JSON.parse(atob(b64));
    return typeof json.exp === 'number' ? json.exp * 1000 : null;
  } catch {
    return null;
  }
}

/** Proactively refresh before access JWT expires; on tab focus. */
export function useSessionRefresh() {
  const { pathname } = useLocation();

  useEffect(() => {
    const skewMs = 5 * 60 * 1000;

    const tick = async () => {
      const token = localStorage.getItem(TOKEN_KEY);
      const refresh = localStorage.getItem(REFRESH_KEY);
      if (!token?.trim() || !refresh?.trim()) return;

      const exp = jwtExpMs(token);
      if (exp == null) return;
      if (exp - Date.now() > skewMs) return;

      const { refreshed, authRejected } = await refreshAccessToken();
      if (authRejected && pathname !== '/login') {
        stashLoginReturnPath(
          `${window.location.pathname}${window.location.search}${window.location.hash}`
        );
        window.location.assign('/login');
      }
      if (!refreshed && !authRejected) {
        /* network or 5xx — keep session */
      }
    };

    tick();
    const id = setInterval(tick, 30_000);

    const onVis = () => {
      if (document.visibilityState === 'visible') tick();
    };
    document.addEventListener('visibilitychange', onVis);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [pathname]);
}
